import { QuestionCategoryRate } from './../../../../models/reporting';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-question-categories-rating-module',
  templateUrl: './question-categories-rating-module.component.html',
  styles: []
})
export class QuestionCategoriesRatingModuleComponent implements OnInit {
  @Input() questionCategoryRates: Array<QuestionCategoryRate>;
 
  constructor() { }

  ngOnInit() {
    this.questionCategoryRates = this.questionCategoryRates.filter(x => x.value !== 0);
  }

  getCategoryIndex(questionCategoryIndex: number, questionCategoriesRate: QuestionCategoryRate) {
    return questionCategoriesRate.value.toFixed(1).toString() + '_'  + questionCategoryIndex.toString();
  }
}
